import React from 'react';

// About Us page component
const AboutUsPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">About Us</h1>

        <div className="privacy-content">
          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">1</span>
              <h2>Who We Are</h2>
            </div>
            <p>
              getphotoshoot.ai is an innovative AI-powered jewelry photography service designed to transform the way jewelry businesses showcase their products. We leverage cutting-edge artificial intelligence to create professional model presentations that bring jewelry to life.
            </p>
            <p>
              A product of <strong>Qressy Solutions Private Limited</strong>, we're committed to providing businesses with powerful, easy-to-use tools that enhance their digital presence and boost sales.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">2</span>
              <h2>Our Mission</h2>
            </div>
            <p>
              Our mission is to democratize professional jewelry photography by making high-quality, AI-generated model presentations accessible to businesses of all sizes. We believe every jewelry piece deserves to be showcased in its best light, and we're here to make that possible.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">3</span>
              <h2>What We Offer</h2>
            </div>
            <p>getphotoshoot.ai provides:</p>
            <ul className="terms-list">
              <li><strong>AI-Powered Image Generation:</strong> Transform jewelry photos into professional model presentations using advanced AI technology</li>
              <li><strong>Multiple Styles:</strong> Choose from realistic, artistic, cartoon, anime, oil painting, and watercolor styles to match your brand aesthetic</li>
              <li><strong>Jewelry Merging:</strong> Seamlessly place jewelry pieces on model images with realistic lighting, shadows, and reflections</li>
              <li><strong>High-Quality Output:</strong> Generate professional-grade images suitable for e-commerce, marketing, and advertising</li>
              <li><strong>Easy-to-Use Interface:</strong> Simple, intuitive platform designed for users of all technical levels</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">4</span>
              <h2>Our Technology</h2>
            </div>
            <p>
              We utilize state-of-the-art AI models , to power our image generation capabilities. Our platform is built with modern web technologies to ensure fast, reliable, and secure service delivery.
            </p>
            <p>
              All images are processed securely, and we maintain high standards for data privacy and security to protect your business information and content.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">5</span>
              <h2>Why Choose Us</h2>
            </div>
            <ul className="terms-list">
              <li><strong>Speed:</strong> Generate professional images in seconds, not days</li>
              <li><strong>Cost-Effective:</strong> Affordable credit-based pricing without expensive photoshoots</li>
              <li><strong>Flexibility:</strong> Multiple styles and customization options to match your brand</li>
              <li><strong>Quality:</strong> Professional-grade results suitable for commercial use</li>
              <li><strong>Support:</strong> Dedicated customer support to help you succeed</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">6</span>
              <h2>Our Company</h2>
            </div>
            <p>
              <strong>Qressy Solutions Private Limited</strong> is a technology company focused on creating innovative solutions for businesses. We're headquartered in India and serve customers globally.
            </p>
            <p>
              Our team combines expertise in artificial intelligence, web development, and business solutions to deliver products that truly make a difference.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">7</span>
              <h2>Get In Touch</h2>
            </div>
            <p>
              We'd love to hear from you! Whether you have questions, feedback, or partnership inquiries, our team is here to help.
            </p>
            <ul className="terms-list">
              <li>Email: <a className="terms-link" href="mailto:success@getphotoshoot.ai">success@getphotoshoot.ai</a></li>
              <li>Support Hours: Monday–Friday, 9:00–18:00 IST</li>
              <li>For partnerships: <a className="terms-link" href="mailto:partners@getphotoshoot.ai">partners@getphotoshoot.ai</a></li>
            </ul>
            <p>
              Visit our <a className="terms-link" href="/contact">Contact Information</a> page for more details.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;

